export const themedefault = {
  containerLayout: {
    width: '100%',
    maxWidth: '1280px',
    fluidWidth: '100%',
    margin: '0 auto',
    mobileWidth: '100%',
    mobileBorderRadius: '32px 32px 0 0',
    mobilePadding: '0 24px',
  },

  button: {
    background: '#E21B22',
    color: '#fff',
    borderRadius: '4px',
    outline: {
      background: '#fff',
      color: '#E21B22',
      borderColor: '#E21B22',
    },
    secondary: {
      background: '#595959',
      color: '#fff',
    },
    small: {
      fontSize: '12px',
      lineHeight: '30px',
      fontWeight: '600',
      padding: '0 24px',
    },
    home: {
      background: '#fff url(https://static.toiimg.com/photo/92430053.cms) no-repeat 10px 7px',
      hoverBackground: '#F6F6F6 url(https://static.toiimg.com/photo/92430053.cms) no-repeat 10px 7px',
      hoverFontWeight: '500',
      color: '#595959',
      borderColor: '#ECECEC',
      homePadding: '0 14px 0 34px',
      backgroundsize: '17px'
    },
    disabled: {
      background: '#ccc',
      color: '#fff',
    },
    link: {
      color: '#E21B22',
      background: 'transparent',
      padding: 0,
    }
  },

  backtotop: {

    background: '#FFF5F6 url(https://static.toiimg.com/photo/97033953.cms) no-repeat 90% center',
    boxShadow: '0px 4px 4px rgba(26, 26, 26, 0.2)',
    borderRadius: '8px 0px 0px 8px',
    position: 'fixed',
    right: '0',
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '24px',
    padding: '8px 48px 8px 24px',
    textTransform: 'uppercase',
    cursor: 'pointer',
    bottom: '50px',
    mobileFontSize: '12px',
    mobileLineHeight: '16px',
    mobileWidth: '136px',
    mobilePadding: '12px 16px',
    mobileZindex: '13',
  },

  socialbutton: {
    borderRadius: '4px',
    border: '1px solid transparent',
    fontSize: '10px',
    lineHeight: '16px',
    fontWeight: '700',
    height: '24px',
    width: '90px',
    textTransform: 'uppercase',
    background: '#ffffff',
    margin: '0 4px',
    padding: '0 6px',

    facebook: {
      borderColor: '#3B5998',
      color: '#3B5998',
    },

    twitter: {
      borderColor: '#56ACEE',
      color: '#56ACEE',
    },

    instagram: {
      borderColor: '#AC3A8A',
      color: '#AC3A8A'
    },

    koo: {
      borderColor: '#383838',
      color: '#383838'
    },

    youtube: {
      borderColor: '#FF0000',
      color: '#FF0000'
    }

  },

  typography: {
    xxsmallFontSize: '10px',
    xsmallFontSize: '12px',
    smallFontSize: '14px',
    fontSize: '16px',
    largeFontSize: '20px',
    xlargeFontSize: '24px',
    mobilelargeFontSize: '16px',
    smallLineHeight: '18px',
    lineHeight: '24px',
    largeLineHeight: '28px',
    xlargelineHeight: '36px',
    mobilelargelineHeight: '24px',
    primaryFontColor: '#595959',
    secondaryFontColor: '1a1a1a',
  },

  navigation: {
    mobileMargin: '0',
    mobilePadding: '16px 0 22px',
    mobileOverflow: 'scroll',
    mobileOverflowY: 'hidden',
    mobileWidth: '100%',
    color: '#1A1A1A',
    fontSize: '16px',
    lineHeight: '24px',
    activeColor: '#E21B22',
    mobileColor: '#595959',
    mobileFontSize: '14px',
    mobileLineHeight: '20px',
    mobileActiveColor: '#E21B22',
    mobileActiveFontWeight: '600',
    marginNavItem: '24px',
    mobileMarginNavItem: '16px',
  },

  inputCalendar: {
    background: '#fff url(https://static.toiimg.com/photo/96055527.cms) no-repeat 20px 14px',
    mobileBackgroundPosition: '95% 11px',
    borderColor: '#ECECEC',
    borderRadius: '12px',
    fontSize: '16px',
    lineHeight: '24px',
    height: '56px',
    padding: '14px 24px 14px 68px',
    color: '#595959',
    placeholderColor: '#cccccc',
    mobileHeight: '52px',
    mobileFontSize: '14px',
    mobileLineHeight: '20px',
    mobilePadding: '14px 24px',
  },

  inputSearch: {
    background: '#f6f6f6 url(https://static.toiimg.com/photo/96846696.cms) no-repeat 97% center',
    mobileBackground: '#fff',
    borderColor: '#ececec',
    borderRadius: '4px',
    color: '#595959',
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '16px',
    mobileWidth: '100%',
    mobileHeight: '50px',
    mobileMargin: '12px 0 0 0',
    backgroundSize: '16px',
  },

  card: {
    border: '1px solid #ececec',
    borderRadius: '24px',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.04);',
    mobileBorder: '1px solid #ececec',
    mobileBorderRadius: '0',
    mobileBoxShadow: 'none',
  },
  link: {
    color: '#E21B22'
  },
  storyblocker: {
    border: '4px solid #FFF5F6',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.04);',
    borderRadius: '24px',
  },
  storyoffers: {
    background: '#FFF5F6',
    borderRadius: '0px 0px 24px 24px;',
  },
  faq: {
    background: '#ffffff',
    border: '1px solid #ECECEC',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.04)',
    borderRadius: '26px',
    padding: '36px 36px 0 36px',
    mobilePadding: '24px',
    mobileMargin: '0 24px',


    title: {
      fontSize: '40px',
      fontWeight: '700',
      lineHeight: '48px',
      mobileFontSize: '28px',
      mobileLineHeight: '32px',
      margin: '40px 0 30px',
      mobileMargin: '24px 24px 16px',
    },
    heading: {
      fontWeight: '600',
      fontSize: '28px',
      lineHeight: '36px',
      mobileFontSize: '16px',
      mobileLineHeight: '24px',
      nonPrimeFontSize: '20px',
    },
    content: {
      border: '1px solid #ECECEC',
      padding: '0 0 44px 0',
      margin: '0 0 44px 22px',
      mobileMargin: '0 0 24px',
      mobilePadding: '0 0 24px 0',

    },
    list: {
      fontSize: '20px',
      lineHeight: '28px',
      fontWeight: '400',
      mobileFontSize: '16px',
      mobileLineHeight: '24px',
      disc: 'disc',
      padding: '12px 0 0',
      mobilePadding: '16px 0 0',
      mobileMargin: '0 0 0 24px',
      color: '#595959',
    }
  },
  HamburgerIcon: {
    width: '24px',
    height: '2px',
    background: '#fff',
    margin: '2px',
  }
};




